import React from 'react';
import PropTypes from 'prop-types';

import s from './MapNoteSheetEditable.module.scss';

const MapNoteDescription = props => {
    const onChange = e => props.onTextChange(e.target.value);
    const clearPlaceholder = e => (e.target.placeholder = '');
    const showPlaceholder = e => (e.target.placeholder = props.placeholder);
    return (
        <div>
            <textarea data-testid="map-note-description" className={s.description} onChange={onChange} value={props.text} placeholder={props.placeholder} onFocus={clearPlaceholder} onBlur={showPlaceholder} />
        </div>
    );
};

MapNoteDescription.propTypes = {
    placeholder: PropTypes.string,
    text: PropTypes.string,
    onTextChange: PropTypes.func.isRequired,
};
MapNoteDescription.defaultProps = {
    placeholder: 'Enter text here...',
    text: '',
};

export default MapNoteDescription;
